export default __webpack_public_path__ + "static/media/lj-hooker.ea63b505.png";